export default () => ({
  hovered: null,
  focused: null,
  pending: null,
  timer: null,
  resizeObserver: null,
  lastX: null,
  lastY: null,
  desktop: null,
  hoverMedia: null,
  onViewportChange: null,

  get activeCard() {
    const index = this.focused ?? this.hovered;
    return index === null ? '' : String(index + 1);
  },

  init() {
    this.desktop = window.matchMedia('(min-width: 1024px)');
    this.hoverMedia = window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
    this.onViewportChange = () => {
      this.cancelPending();
      this.updateDescriptionWidths();
      this.hovered = null;
      this.focused = null;
      this.lastX = this.lastY = null;
    };
    this.desktop.addEventListener('change', this.onViewportChange);
    this.hoverMedia.addEventListener('change', this.onViewportChange);
    this.updateDescriptionWidths();
    this.resizeObserver = new ResizeObserver(() => this.updateDescriptionWidths());
    this.resizeObserver.observe(this.$el);
  },

  cancelPending() {
    window.clearTimeout(this.timer);
    this.timer = null;
    this.pending = null;
  },

  updateDescriptionWidths() {
    // Measure the grid, not its animating columns: paragraph widths remain stable.
    const gap = parseFloat(window.getComputedStyle(this.$el).columnGap) || 0;
    const available = Math.max(0, this.$el.clientWidth - gap * 2);
    this.$el.style.setProperty('--product-description-rest', available / 3 + 'px');
    this.$el.style.setProperty('--product-description-expanded', available * 1.4 / 3.4 + 'px');
  },

  select(property, index) {
    this[property] = index;
  },

  schedule(index) {
    if (this.timer !== null && this.pending === index) return;
    this.cancelPending();
    if (this.hovered === index) return;
    this.pending = index;
    this.timer = window.setTimeout(() => {
      this.select('hovered', index);
      this.timer = null;
      this.pending = null;
    }, 100);
  },

  pointerMove(event) {
    if (!this.hoverMedia.matches || event.pointerType === 'touch') return;
    // Resizing cards must not switch selection beneath a stationary pointer.
    if (event.clientX === this.lastX && event.clientY === this.lastY) return;
    this.lastX = event.clientX;
    this.lastY = event.clientY;
    const card = event.target.closest('[data-product-index]');
    if (!card || !card.querySelector('a')) {
      this.cancelPending();
      return;
    }
    this.schedule(Number(card.dataset.productIndex));
  },

  pointerLeave() {
    this.lastX = this.lastY = null;
    this.schedule(null);
  },

  focusIn(event) {
    if (!this.desktop.matches || !event.target.matches('a:focus-visible')) return;
    const card = event.target.closest('[data-product-index]');
    if (card) this.select('focused', Number(card.dataset.productIndex));
  },

  focusOut(event) {
    if (!event.relatedTarget || !this.$el.contains(event.relatedTarget)) this.select('focused', null);
  },

  destroy() {
    this.cancelPending();
    if (this.resizeObserver) this.resizeObserver.disconnect();
    this.desktop.removeEventListener('change', this.onViewportChange);
    this.hoverMedia.removeEventListener('change', this.onViewportChange);
  },
});
